import React, { type ReactNode, createContext } from "react";

import { StringParam, useQueryParams, withDefault } from "use-query-params";

export type SortingOption = "name" | "updatedAt";

interface Filters {
  search: string;
  sorting: SortingOption;
}

interface FiltersContext {
  filters: Filters;
  setFilters: (filters: Partial<Filters>) => void;
}

export const FiltersContext = createContext<FiltersContext | null>(null);

export const FiltersProvider = ({ children }: { children: ReactNode }) => {
  const [filters, setFilters] = useQueryParams({
    search: withDefault(StringParam, ""),
    sorting: withDefault(StringParam, "name"),
  });

  return (
    <FiltersContext.Provider
      value={{
        filters: {
          search: filters.search,
          sorting: filters.sorting as SortingOption,
        },
        setFilters: (filters) => setFilters(filters),
      }}
    >
      {children}
    </FiltersContext.Provider>
  );
};
